module.exports = __webpack_public_path__ + "static/media/udatatrack-header-bg.496a9ff9.svg";